import { Router } from '@angular/router';
import { NavigationClient, NavigationOptions } from '@azure/msal-browser';

/**
 * Custom MSAL navigation client that delegates internal navigations
 * (e.g. navigateToLoginRequestUrl after auth redirect) to the Angular Router
 * instead of the default window.location.replace().
 *
 * Using window.location.replace() causes a spurious full-page document request
 * on first load / refresh (visible in DevTools as type: document, Initiator: Other,
 * HTTP 404 on Azure Static Web / Blob Storage) because MSAL navigates back to the
 * original route natively, bypassing Angular's client-side routing.
 */
export class MsalNavigationClient extends NavigationClient {
  constructor(private readonly router: Router) {
    super();
  }

  override async navigateInternal(
    url: string,
    options: NavigationOptions
  ): Promise<boolean> {
    const internalUrl = url.replace(window.location.origin, '');

    if (options.noHistory) {
      await this.router.navigateByUrl(internalUrl, { replaceUrl: true });
    } else {
      await this.router.navigateByUrl(internalUrl);
    }

    return false;
  }
}
